<nz-spin [nzSpinning]="loading$ | async"
  ><form
    [formGroup]="organizationUserForm"
    (ngSubmit)="onSubmit()"
    nz-form
    class="user-form form"
    nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>Username</nz-form-label>
        <nz-form-control [nzErrorTip]="emailErrorTpl">
          <input
            name="email"
            type="text"
            nz-input
            id="email"
            formControlName="email"
            placeholder="Enter your user name" />
          <ng-template #emailErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your username.
            </ng-container>
            <ng-container
              *ngIf="control.hasError('email') || control.hasError('pattern')">
              Please enter a valid username.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
        <nz-form-control [nzErrorTip]="firstNameErrorTpl">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="firstName"
            formControlName="firstName"
            placeholder="Enter your first name" />
          <ng-template #firstNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your first name.
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              First name must be at least 2 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              First name can not exceed 50 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')">
              Spaces are not allowed at the start or end.
            </ng-container>
            <ng-container
              *ngIf="
                control.hasError('empty') &&
                !control.hasError('minlength') &&
                !control.hasError('maxlength')
              ">
              Please enter a valid first name!
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
        <nz-form-control [nzErrorTip]="lastNameErrorTpl">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="lastName"
            formControlName="lastName"
            placeholder="Enter your last name" />
          <ng-template #lastNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your last name.
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              Last name must be at least 2 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Last name can not exceed 50 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')">
              Spaces are not allowed at the start or end.
            </ng-container>
            <ng-container
              *ngIf="
                control.hasError('empty') &&
                !control.hasError('minlength') &&
                !control.hasError('maxlength')
              ">
              Please enter a valid last name.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="titleId" nzRequired>Title</nz-form-label>
        <nz-form-control nzErrorTip="Please select your title.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            id="titleId"
            formControlName="titleId"
            nzPlaceHolder="Select a title"
            name="title"
            (ngModelChange)="onTitleChange($event)">
            @for (title of titleList; track title) {
              <nz-option
                [nzLabel]="title.title"
                [nzValue]="title.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="roleIds" nzRequired>User Role</nz-form-label>
        <nz-form-control nzErrorTip="Please select your user roles.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzMode="multiple"
            nzShowArrow="true"
            nzPlaceHolder="Select a roles"
            formControlName="roleIds"
            [nzNotFoundContent]="loadingContent.loadingTemplate"
            name="roleIds"
            [nzDisabled]="isDisableAllCheckBox">
            @for (role of roleList | async; track role) {
              <nz-option [nzLabel]="role.name" [nzValue]="role.id"></nz-option>
            }
          </nz-select>
          <app-loading-content
            #loadingContent
            [isLoading$]="isLoading"
            noDataText="No roles found">
          </app-loading-content>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="statusId" nzRequired>Status</nz-form-label>
        <nz-form-control nzErrorTip="Please select your status.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select a status"
            formControlName="statusId"
            name="statusId">
            @for (status of statusList; track status) {
              <nz-option
                [nzLabel]="status.value | titlecase"
                [nzValue]="status.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <div class="display-flex justify-content-between drawer-footer">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawer()">
          Cancel
        </button>
        <button
          nz-button
          type="submit"
          nzType="primary"
          [nzLoading]="loading"
          [disabled]="!organizationUserForm.valid">
          Add User
        </button>
      </div>
    </div>
  </form>
</nz-spin>
